import React from 'react';

import {
  Container,
  Description,
  HiddenInput,
  LabelContent,
  LabelText,
  Thumb,
  Track,
} from './styled';
import { getToggleSizeTokens } from './toggle-styles';
import type { ToggleProps } from './types';

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  defaultChecked,
  onChange,
  size = 'medium',
  label,
  description,
  labelPosition = 'right',
  disabled = false,
  className,
  testId,
  styleProps,
  ...props
}) => {
  const [internalChecked, setInternalChecked] = React.useState(defaultChecked ?? false);
  const isControlled = checked !== undefined;
  const checkedValue = isControlled ? checked : internalChecked;

  const tokens = getToggleSizeTokens(size);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked;
    if (!isControlled) {
      setInternalChecked(newChecked);
    }
    onChange?.(newChecked);
  };

  return (
    <Container
      $disabled={disabled}
      $labelPosition={labelPosition}
      className={className}
      data-testid={testId}
    >
      <Track
        $checked={checkedValue}
        $disabled={disabled}
        $trackWidth={tokens.trackWidth}
        $trackHeight={tokens.trackHeight}
        $thumbSize={tokens.thumb}
        $translate={tokens.translate}
        $styleProps={styleProps}
      >
        <Thumb
          $checked={checkedValue}
          $disabled={disabled}
          $trackWidth={tokens.trackWidth}
          $trackHeight={tokens.trackHeight}
          $thumbSize={tokens.thumb}
          $translate={tokens.translate}
          $styleProps={styleProps}
        />
      </Track>
      <HiddenInput
        type='checkbox'
        checked={checkedValue}
        onChange={handleChange}
        disabled={disabled}
        {...props}
      />
      {(label || description) && (
        <LabelContent>
          {label && (
            <LabelText $disabled={disabled} $styleProps={styleProps}>
              {label}
            </LabelText>
          )}
          {description && (
            <Description $disabled={disabled} $styleProps={styleProps}>
              {description}
            </Description>
          )}
        </LabelContent>
      )}
    </Container>
  );
};